// @ts-check

import { useLanguageStore } from '@/store/language'
import { mapState } from 'pinia'

/** @type {import("vue").ComponentOptionsMixin} */
export const datepickerMixin = {
  data: () => ({
    picker: undefined
  }),
  computed: {
    ...mapState(useLanguageStore, ['language'])
  },
  watch: {
    language() {
      // Picker not always loaded in certain situations causing error without this check
      if (this.picker) {
        this.picker._o.i18n = this.getTranslations()
      }
    }
  },
  methods: {
    getTranslations() {
      return {
        previousMonth: this.$t('dates.previousMonth'),
        nextMonth: this.$t('dates.nextMonth'),
        months: this.$tm('dates.months'),
        weekdays: this.$tm('dates.weekdays'),
        weekdaysShort: this.$tm('dates.weekdaysShort')
      }
    }
  }
}

export default {}
